import { State } from "@app/root-store/app.state";
import { createSelector } from "@ngrx/store";
import { EventLogState, initialEventLogState } from "../reducers/event-log.reducers";

const selectFeature = (state: State) => state["event-log-reducer"];

export const selectActivityLog = createSelector(
    selectFeature,
    (state: EventLogState) => state?.activityLog || initialEventLogState.activityLog
);

/**
 *
 * @param key
 * @returns
 */
export const selectActivityLogByFilter = (key: string) =>
    createSelector(selectActivityLog, storedData => {
        if (!storedData || !storedData.result[key]) {
            return null;
        }

        return storedData.result[key] || [];
    });
/**
 * get activity log call state
 *
 * @returns { CallState }
 */
export const selectActivityLogCallState = () => createSelector(selectActivityLog, activityLog => activityLog.callState);
